<template>
    <main>
        <div class="container-fluid message">
            <TopTemplate>
                <template #right-element>
                    <div class="top-btn">
                        <router-link :to="{ name: 'Message' }" class="btn btn-outline-primary button" :disabled="loading">
                            <i class="arrow left"></i>
                            {{ $t("button.retour") }}
                        </router-link>
                    </div>
                </template>
                <template #left-element>
                    <h3>{{ $t("title.repMsg") }}</h3>
                </template>
            </TopTemplate>

            <div class="card top-card">
                <div class="row top-msg ">
                    <div class="col-md-12 content-msg">
                        <h3>Contenu</h3>
                    </div>

                    <div class="col-md-6 content-msg">

                        <p><strong>Expéditeur :</strong>{{ monObjetMsg.from.first_name }} {{ monObjetMsg.from.last_name }} </p>
                        <p><strong>Date : </strong> Le
                            <span v-if="checkLanguag(monObjetMsg.message)" :class="{ 'arab-text': checkLanguag(monObjetMsg.message) }"
                                  class="text-date">{{ formatDateAR(monObjetMsg.created_at) }} - {{ formatDateString(monObjetMsg.created_at)
                                }}
              </span>
                            <span v-else :class="{ 'arab-text': checkLanguag(monObjetMsg.message) }" class="text-date">
                {{ formatDateString(monObjetMsg.created_at) }}</span>
                        </p>


                        <div class="content-msg__bottom">
                            <p><strong>Message : </strong>
                                <span :class="{ 'arab-text': checkLanguag(monObjetMsg.message) }" class="text-normal content-editor"
                                      v-html="monObjetMsg.message"></span>
                            </p>

                        </div>
                    </div>
                    <div class="col-md-4">
            <span v-if="monObjetMsg.files.length === 0">
              {{ $t("common.emptyFiles") }}
            </span>
                        <span v-else class="col-md-5" v-for="(file, index) in monObjetMsg.files" :key="index"><i
                            class="icon-file-04"></i>
              <a :href="file.file_url" class="files" download> {{ file.file_name }}</a>
            </span>
                    </div>
                </div>
            </div>
            <div class="card ">
                <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
                    <div class="spinner-border text-info" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>

                <div class="col-md-10">
                    <h3>Répondre sur le message </h3>
                    <div v-if="msgs.length === 0" class=" input-container simple-input">
                        <input v-model="yourMsg" type="text" class="form-control" placeholder="Répondre au message ..."
                               @keyup.enter="addMsg()">
                        <div class="icone-file">
                            <label class="input-image input-files" for="otherDoc" @change="onFileChange" @click="resetFileUploader">
                                <div class="icon-upload">
                                    <img src="../../assets/icons/file.png" />
                                </div>
                                <input
                                    id="otherDoc"
                                    type="file"
                                    ref="file"
                                    :multiple="true"
                                    class="d-none"
                                    accept=".pdf, .xls, .xlsx, .xlsm, .docx, .ppt, .pdf, .jpeg, .jpg, .png"
                                    tabindex="-1"
                                />
                            </label>
                        </div>
                        <div v-if="loadingMsg" class="spinner-box icon-button ">
                            <div class="pulse-container">
                                <div class="pulse-bubble pulse-bubble-1"></div>
                                <div class="pulse-bubble pulse-bubble-2"></div>
                                <div class="pulse-bubble pulse-bubble-3"></div>
                            </div>
                        </div>


                        <button type="button" class="icon-button " @click="addMsg()" :disabled="btnDisplay">
                            <img src="../../assets/icons/envoi-icon.png">
                        </button>
                    </div>
                    <div class="col-md-12 files-name" v-if="tabfile.length && msgs.length === 0">
                        <ul class="justify-- d-flex">
                            <li v-for="(item, index) in tabfile" :key="index">
                                {{ item.name }}
                                <span class="btn-close-file" @click="deletefile(index)"></span>
                            </li>
                        </ul>
                    </div>

                    <div v-for="msg in msgs" :key="msg.id" class="all-msg padding-section msg__top">

                        <div class="top__msg">
                            <div class="all-msg__name">
                                <p>{{ msg.from.first_name }} {{ msg.from.last_name }}</p>
                            </div>
                            <div class="all-msg__content">
                                <p>{{ msg.message }}</p>
                            </div>
                            <div class="all-msg__info">
                                <div class="all-msg__info__rep">
                                    <button class="repondre_msg"
                                            @click="repondreMsg(msg, index), replyToResponseId = msg.id">Répondre</button>
                                </div>
                                <div class="all-msg__info__date">
                                    <p>{{ formatCustomDateTime(msg.created_at) }}</p>
                                </div>
                            </div>
                            <div class="files-list liste-padding">
                <span class="col-md-12 files-list__span" v-for="(file, index) in msg.files" :key="index"><i class="icon-file-04"></i>
                  <a :href="file.file_url" class="files" download> {{ file.file_name }}</a>
              </span>
                            </div>

                        </div>
                        <div v-if="selectReponse === msg.id" class="input-rep input-container simple-input">
                            <input v-model="yourMsgRepondre" type="text" class="form-control"
                                   @keyup.enter="addMsg(), isAddingMessage = true" placeholder="Répondre au message ...">
                            <div class="icone-file">
                                <label class="input-image input-files" for="otherDoc" @change="onFileChange" @click="resetFileUploader">
                                    <div class="icon-upload">
                                        <img src="../../assets/icons/file.png" />
                                    </div>
                                    <input
                                        id="otherDoc"
                                        type="file"
                                        ref="file"
                                        :multiple="true"
                                        class="d-none"
                                        accept=".pdf, .xls, .xlsx, .xlsm, .docx, .ppt, .pdf, .jpeg, .jpg, .png"
                                        tabindex="-1"
                                    />
                                </label>
                            </div>

                            <div v-if="loadingMsg" class="spinner-box icon-button ">
                                <div class="pulse-container">
                                    <div class="pulse-bubble pulse-bubble-1"></div>
                                    <div class="pulse-bubble pulse-bubble-2"></div>
                                    <div class="pulse-bubble pulse-bubble-3"></div>
                                </div>
                            </div>

                            <button type="button" class="icon-button" :disabled="btnDisplay" @click="addMsg()">
                                <img src="../../assets/icons/envoi-icon.png">
                            </button>

                        </div>
                        <div class="col-md-12 files-name file-add" v-if="tabfile.length && selectReponse === msg.id">
                            <ul class="justify-- d-flex">
                                <li v-for="(item, index) in tabfile" :key="index">
                                    <i class="icon-file-04"></i>
                                    {{ item.name }}
                                    <span class="btn-close-file" @click="deletefile(index)"></span>
                                </li>
                            </ul>
                        </div>


                        <div v-for="(response, index) in msg.responses" :key="index" class="all-msg level" :id="`message-${response.created_at}`">
                            <div class="all-msg__name">
                                <p>{{ response.from.first_name }} {{ response.from.last_name }} </p>
                            </div>
                            <div class="all-msg__content">
                                <p>{{ response.message }}</p>
                            </div>
                            <div class="all-msg__info">
                                <div class="all-msg__info__date">
                                    <p>{{ formatCustomDateTime(response.created_at) }}</p>
                                </div>
                            </div>
                            <div class="files-list">
                <span class="col-md-12 files-list__span " v-for="(file, index) in response.files" :key="index"><i class="icon-file-04"></i>
                  <a :href="file.file_url" class="files" download> {{ file.file_name }}</a>
              </span>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>
    </main>
</template>
<script>
import MessageService from "../../services/message.service";
import moment from "moment";
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import _ from "lodash";

export default {
    name: "detailMsg",
    components: {
        TopTemplate,
    },
    data() {
        return {
            loading: false,
            msgs: [],
            yourMsg: "",
            monObjetMsg: null,
            idMsg: null,
            showInputRepondre: false,
            msgEnvoye: "",
            replyToResponseId: null,
            btnDisplay: false,
            isAddingMessage: false,
            loadingMsg: false,
            selectReponse: null,
            tabfile:[],
        };
    },
    computed: {},
    created() {
        const jsonString = localStorage.getItem("monObjetMsg");
        if (jsonString) {
            this.monObjetMsg = JSON.parse(jsonString);
        }
        this.moment = moment;
        this.referenceId = this.$route.params.id;
    },
    mounted() {
        this.getDetails();
    },

    methods: {
        deletefile(index) {
            this.tabfile.splice(index, 1);
        },
        resetFileUploader() {
            this.$refs.file.value = "";
        },
        onFileChange(event) {
            this.maxLengthFiles = false;
            const files = Object.entries(event.target.files).map(([key, value]) => value);
            const newFiles = [];

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if (!this.tabfile.includes(file)) {
                    newFiles.push(file);
                }
            }

            if (this.tabfile.length + newFiles.length <= 5) {
                this.tabfile = this.tabfile.concat(newFiles);
            }
            else {
                this.maxLengthFiles = true;
            }
            console.log(this.tabfile)

            this.validateFiles();
        },
        validateFiles() {
            for (let i = 0; i < this.tabfile.length; i++) {
                const file = this.tabfile[i];
                if (file.size > 2 * 1024 * 1024) {
                    this.tabfile.splice(i, 1);
                    this.maxFileSize = true;
                    i--;
                }
            }
        },
        checkLanguag(val) {
            const arabic = /[\u0600-\u06FF]/;
            return arabic.test(val); // displays true
        },
        formatDateAR(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        formatDateString(dateString) {
            const formattedDate = moment(dateString).format('DD MMMM YYYY', 'fr');
            return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
        },
        formatCustomDateTime(dateTimeString) {
            const formattedDateTime = moment(dateTimeString).format('DD-MM-YYYY  HH:mm');
            return formattedDateTime;
        },

        repondreMsg(msg, index) {
            this.showInputRepondre = true;
            this.idMsg = msg.id;
            this.selectReponse = msg.id;
        },
        getDetails() {
            this.loading = true;
            MessageService.getConversation(this.referenceId)
                .then((response) => {
                    this.msgs = response.data.data;
                    this.loading = false;

                })
                .catch((error) => {
                    console.error(error);
                })
        },
        addMsg(id) {

            if (!this.isAddingMessage) {
                this.btnDisplay = true;

                if (!this.idMsg) {
                    this.idMsg = this.referenceId
                }

                if (this.yourMsgRepondre) {
                    this.msgEnvoye = this.yourMsgRepondre;
                }
                else {
                    this.msgEnvoye = this.yourMsg;

                }
                if (this.msgEnvoye) {
                    this.loadingMsg = true;

                    let formData = new FormData();
                    formData.append("_method", "POST");
                    formData.append("message", this.msgEnvoye);
                    formData.append("user_id", this.monObjetMsg.from.id);
                    formData.append("parent_id", this.idMsg);
                    for (var i = 0; i < this.tabfile.length; i++) {
                        let file = this.tabfile[i];
                        formData.append("files[" + i + "]", file);
                    }
                    const data = {
                        message: this.msgEnvoye,
                        user_id: this.monObjetMsg.from.id,
                        parent_id: this.idMsg,
                    };
                    MessageService.postConversation(this.referenceId, formData)

                        .then((response) => {
                            this.getDetails();
                            this.yourMsg = "";
                            this.yourMsgRepondre = "";
                            this.showInputRepondre = false
                            this.idMsg = null;
                            this.tabfile=[];

                        })

                        .finally(() => {
                            this.getDetails();
                            this.tabfile=[];
                            this.yourMsg = "";
                            this.yourMsgRepondre = "";
                            this.showInputRepondre = false
                            this.idMsg = null;
                            this.resetFileUploader();
                            this.loading = false;
                            this.btnDisplay = false;
                            this.isAddingMessage = false;
                            this.loadingMsg = false;
                            this.selectReponse = null;
                        });
                }
            }
        },
    },
};
</script>
<style scoped lang="scss">
.top-card {
    margin-bottom: 25px;
}

.top-template h3,
.top-template .h3 {
    font-weight: 700;
    font-size: 16px;
    font-family: "Montserrat";
    color: #34b9bb;
    margin-bottom: 0;
}

.top__msg {
    padding-left: 50px;
}

.msg__top:not(:last-child) {
    border-bottom: 1px solid #DCDCDC;
}

.all-msg.level {
    margin-left: 80px;
    border-left: 1px solid #DCDCDC;
    padding-left: 15px;
}

.level-1 {
    margin-top: 20px;
    margin-left: 80px;
    border-left: 1px solid #DCDCDC;
    padding-left: 15px;
}

.top-msg {
    padding-bottom: 20px;
}

.all-msg.padding-section.msg__top {
    padding-bottom: 20px;
    padding-top: 20px;
}

h3 {
    color: #3D3D3D;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px;
    margin-bottom: 25px;
}

.card {
    padding: 25px;
}
.all-msg {
    padding-top: 10px;

    &__name {
        p {
            margin: 0;
            color: #377879;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 23px;
            /* 143.75% */
        }
    }

    &__content {
        p {
            color: #000;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            margin: 0;
        }
    }

    &__info {
        display: inline-flex;

        p {
            margin: 0;
        }

        .repondre_msg {
            position: relative;
            color: #F35B19;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 23px;
            padding-right: 10px;

            &::after {
                position: absolute;
                top: 5px;
                right: 0;
                width: 1px;
                height: 12px;
                background: #A098AE;
                content: "";
            }

        }

        &__rep {
            p {
                position: relative;
                color: #F35B19;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: 23px;
                padding-right: 10px;

                &::after {
                    position: absolute;
                    top: 5px;
                    right: 0;
                    width: 1px;
                    height: 12px;
                    background: #A098AE;
                    content: "";
                }
            }
        }

        &__date {
            p {
                color: #A098AE;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: 23px;
                padding-left: 10px;
            }
        }
    }
}
.input-image {
    padding: 0;
}

.icone-file {
    position: absolute;
    left: 5px;
    background-color: #34b9bb2b !important;
    padding: 5px !important;
    border-radius: 6px !important;
    padding-top: 3px !important;
    img {
        height: auto !important;
        width: auto !important;
    }
}
.input-rep {
    margin-left: 50px;
    margin-top: 15px;
}

/* Style du conteneur de l'input et du bouton icône */
.input-container {
    display: flex;
    align-items: center;
    border-radius: 10px;
    border: 1px solid #DCDCDC;
    padding: 6px;
    height: 35px;
}

/* Style de l'input */
.input-container input[type="text"] {
    flex: 1;
    border: none;
    outline: none;
    padding: 4px;
    height: 25px;
    padding-left: 35px;

    &::placeholder {
        color: #A4A8AB;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        /* 153.846% */
    }
}

/* Style du bouton icône */
.icon-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
}

/* Style de l'icône */
.icon-button img {
    width: 20px;
    height: 20px;
}

.spinner-box {
    //width: 300px;
    //height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
}

@keyframes pulse {
    from {
        opacity: 1;
        transform: scale(1);
    }

    to {
        opacity: .25;
        transform: scale(.75);
    }
}

.pulse-container {
    width: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 10px;

}

.pulse-bubble {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #34B9BB;
}

.pulse-bubble-1 {
    animation: pulse .4s ease 0s infinite alternate;
}

.pulse-bubble-2 {
    animation: pulse .4s ease .2s infinite alternate;
}

.pulse-bubble-3 {
    animation: pulse .4s ease .4s infinite alternate;
}
.file-add {
    margin-left: 50px;
    padding-top: 0;
}
.files-list{
    &__span {
        list-style: none;
        align-items: center;
        color: #377879;
        font-size: 12px;
        padding: 5px 10px;
        border-radius: 5px;
        margin-bottom: 6px;
        font-weight: 500;
        font-weight: 500;
        padding-right: 0;
        a {
            color: #747474;
            margin-right: 7px;
        }
    }

}
.liste-padding {
    .files-list__span {
        padding-left: 0;
        padding-right: 15px;

    }
}
</style>
